
import { TimeManagementKeys } from '@/i18n/types';

export const timeManagement: Record<TimeManagementKeys, string> = {
  timeManagement: 'Time Management',
  schedule: 'Schedule',
  timeDesc: 'Organize your day and manage your time effectively.',
  pomodoroTimer: 'Pomodoro Timer',
  startTimer: 'Start Timer',
  pauseTimer: 'Pause Timer',
  resetTimer: 'Reset Timer',
  work: 'Work',
  shortBreak: 'Short Break',
  longBreak: 'Long Break',
  focusTime: 'Focus Time',
  breakTime: 'Break Time',
  workTime: 'Work Time',
  addEvent: 'Add Event',
  eventTitle: 'Event Title',
  startTime: 'Start Time',
  endTime: 'End Time',
  addSpecialDate: 'Add Special Date',
  specialDateTitle: 'Special Date Title',
  specialDateType: 'Special Date Type',
  specialDatesTitle: 'Special Dates',
  birthday: 'Birthday',
  anniversary: 'Anniversary',
  reminder: 'Reminder',
  holiday: 'Holiday',
  other: 'Other',
  weekly: 'Weekly',
  daily: 'Daily',
  monthly: 'Monthly',
  weeklySchedule: 'Weekly Schedule',
  weekOf: 'Week of',
  time: 'Time',
  workComplete: 'Work Session Complete',
  breakComplete: 'Break Complete',
  timeForABreak: 'Time for a short break!',
  timeToFocus: 'Time to focus again!',
  toggleSound: 'Toggle Sound',
  viewAllSpecialDates: 'View All Special Dates',
  viewAllSpecialDatesDesc: 'View and manage all your special dates in one place.',
  allSpecialDates: 'All Special Dates',
  date: 'Date',
  title: 'Title',
  type: 'Type',
  actions: 'Actions',
  edit: 'Edit',
  delete: 'Delete',
  specialDateDeleted: 'Special date successfully deleted',
  errorDeletingSpecialDate: 'Error deleting special date',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  viewMode: 'View Mode',
  dailyView: 'Daily View',
  weeklyView: 'Weekly View',
  monthlyView: 'Monthly View',
  yearlyView: 'Annual Summary',
  dailySchedule: 'Daily Schedule',
  monthlySchedule: 'Monthly Schedule',
  repeatsAnnually: 'Repeats Annually',
  repeatsAnnuallyDesc: 'This date will be shown every year',
  noSpecialDates: 'No special dates found',
  loading: 'Loading...',
  timeBlocks: 'Time Blocks',
  analytics: 'Analytics',
  templates: 'Templates',
  annualCalendar: 'Annual Calendar'
};
